<template>
  <div class="wrapper">
    <div class="bg-card">
      <div class="d-flex justify-content-between">
        <strong>{{ $t('pages.user-cv.text-cv.title', 'CV in text') }}</strong>
        <b-button
          v-if="$route.name == 'my-cv'"
          class="cv-button"
          @click="$emit('textCvModalOpen')"
        >
          {{ $t('pages.user-cv.text-cv.edit-button', 'Edit CV in text') }}
        </b-button>
      </div>
      <hr class="mb-0">
      <div>
        <div
          v-if="textCv"
          class="text-cv"
        >
          {{ textCv }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    textCv: {
      type: String,
      default: ""
    },
  }
}
</script>

<style lang="scss" scoped>
  .text-cv {
    white-space: pre-line;
  }
</style>
